module.exports = __webpack_public_path__ + "static/media/pyv-save-and-exit.77879bcc.gif";